import { useTheme } from '@/hooks/useTheme';

interface LogoProps {
    className?: string;
    alt?: string;
    forceDark?: boolean; // Force dark logo regardless of theme (for footer)
}

export function Logo({ className = 'h-8', alt = 'PlanWise - Multi-platform content planning and analytics', forceDark = false }: LogoProps) {
    const { theme } = useTheme();

    // Use dark logo if forceDark is true, otherwise use theme-based logic
    const logoSrc = forceDark ? '/PlanWise Dark.svg'
        : theme === 'dark' ? '/PlanWise Dark.svg' : '/PlanWise Light.svg';

    return (
        <img
            src={logoSrc}
            alt={alt}
            className={className}
        />
    );
}
